/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Match_Reason_External_IdInputs */

const cs_import_match_reason_external_id = /** @type {(inputs: Import_Match_Reason_External_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoda podle externího ID`)
};

const en_import_match_reason_external_id = /** @type {(inputs: Import_Match_Reason_External_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matched by external id`)
};

/**
* | output |
* | --- |
* | "Matched by external id" |
*
* @param {Import_Match_Reason_External_IdInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_match_reason_external_id = /** @type {((inputs?: Import_Match_Reason_External_IdInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Match_Reason_External_IdInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_match_reason_external_id(inputs)
	return cs_import_match_reason_external_id(inputs)
});